module.exports = __webpack_public_path__ + "static/media/33.2f5dd6ce.svg";